export const ScrollListData: scrollListType[] = [
  {
    id: 1,
    name: 'Home',
  },
  {
    id: 2,
    name: 'Skills',
  },
  {
    id: 3,
    name: 'Projects',
  },
  {
    id: 4,
    name: 'Resume',
  },
  {
    id: 5,
    name: 'Contact Me',
  },
]
